import React, { useEffect, useState } from 'react';
import './VirtualMallActivation.scss';
import { virtualMallProductListApi } from './VirtualMallApi/api';
import { imgBaseurl } from '../../baseUrl/baseurl.ts';
import { toast } from 'react-toastify';
import { ThreeCircles } from 'react-loader-spinner';

export default function VirtualMallActivation({ onBuyProduct }) {
    const [activationData] = useState({
        activeLinks: 12,
        totalLinks: 25,
        conversionRate: '48%',
        recentActivations: 5
    });

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const response = await virtualMallProductListApi();
            if (response && response.status && response.data) {
                console.log(response.data, 'Virtual mall products----');
                setProducts(response.data);
                // toast.success("Products loaded successfully!"); // Optional: usually we don't toast on initial load success unless requested, but user asked for "api response message for toast"
            } else {
                toast.error("Failed to load products.");
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            toast.error("An error occurred while fetching products.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);


    return (
        <div className="dashboard-section">
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                    <ThreeCircles
                        height="100"
                        width="100"
                        color="#4fa94d"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="three-circles-rotating"
                        outerCircleColor=""
                        innerCircleColor=""
                        middleCircleColor=""
                    />
                </div>
            ) : (
                <>
                    <h2>Activation Dashboard</h2>
                    <p style={{ color: "#000", textAlign: "center", marginBottom: "20px", fontSize: "14px", fontWeight: "bold", lineHeight: "1.5", maxWidth: "800px", margin: "0 auto 20px auto" }}>When you purchase the product, 12 user IDs are created under your profile.
                        You can share each user ID and password with other users, allowing them to log in separately and manage their own accounts, while all accounts remain linked to your profile.</p>

                    <div className="action-section">
                        <h2 style={{ textAlign: "left", marginBottom: "20px", fontSize: "24px", fontWeight: "bold", color: "#000" }}>Products</h2>
                        <div className="products-grid">
                            {products.map(product => (
                                <div key={product.vmproduct_id} className="product-card">
                                    <div className="product-image">
                                        <img
                                            src={product.vmproduct_image ? `${imgBaseurl}/${product.vmproduct_image}` : 'https://via.placeholder.com/400x300?text=No+Image'}
                                            alt={product.vmproduct_name}
                                            onError={(e) => { e.target.src = 'https://via.placeholder.com/400x300?text=No+Image' }}
                                        />
                                    </div>
                                    <div className="product-details">
                                        <h4 className="product-name">{product.vmproduct_name}</h4>
                                        <p className="product-description">{product.vmproduct_description || 'Virtual Mall Product'}</p>
                                        <div className="product-footer">
                                            <div className="product-price">₹{Number(product.vmproduct_price).toFixed(2)}</div>
                                            <button
                                                className="buy-btn"
                                                onClick={() => onBuyProduct({
                                                    id: product.vmproduct_id,
                                                    name: product.vmproduct_name,
                                                    price: product.vmproduct_price,
                                                    image: product.vmproduct_image
                                                })}
                                            >
                                                🛒 Buy Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
